import { SandboxResponse } from '../types';
import { IHttpService } from './http-service';
import { HttpMethod } from './types';

/** Request body for the sandbox execute endpoint. */
export type SandboxExecuteRequest = {
  functionName: string;
  inputs: unknown[];
  moduleVariables: Record<string, unknown>;
  script: string;
  sessionVariables: Record<string, unknown>;
};

export class ProcessEngineService {
  static readonly baseUrl = '/process-engine/v2/app';
  static readonly sandboxBaseUrl = '/process-engine/test/sandbox';

  private _httpService: IHttpService;
  private _sandboxHttpService: IHttpService;

  constructor(
    httpService: IHttpService,
    sandboxHttpService: IHttpService
  ) {
    this._httpService = httpService;
    this._sandboxHttpService = sandboxHttpService;
  }

  async executeSandbox(
    body: SandboxExecuteRequest,
    endpoint: string
  ): Promise<SandboxResponse> {
    return this._sandboxHttpService.fetchJsonOrFail({
      body,
      headers: { endpoint },
      method: HttpMethod.post,
      url: 'execute'
    });
  }

  async runTest(
    branchId: string,
    version: string,
    body: string,
    headers: Record<string, string>
  ): Promise<any> {
    return (await this._httpService.fetchJsonOrFail({
      body,
      method: HttpMethod.post,
      url: `${branchId}/${version}/run`,
      headers
    }));
  }
}
